import { motion } from 'framer-motion';
import { LayoutGrid, Refrigerator, Snowflake, Flame, Shirt, Tv, Microwave, Heater, CookingPot, Blend, CupSoda, UtensilsCrossed, Waves, Scissors, Wind, Coffee, Tag } from 'lucide-react';

export const ICONES = {
  geladeiras: Refrigerator,
  freezers: Snowflake,
  fogoes: Flame,
  centrifugas: Shirt,
  'smart-tvs': Tv,
  microondas: Microwave,
  fornos: Heater,
  fritadeiras: CookingPot,
  batedeiras: Blend,
  liquidificadores: CupSoda,
  utensilios: UtensilsCrossed,
  ferros: Waves,
  maquinas: Scissors,
  hair: Wind,
  chaleiras: Coffee,
  balcoes: LayoutGrid,
};

export function IconeCategoria({ id, size = 22, className = '' }) {
  const Icone = ICONES[id] || Tag;
  return <Icone size={size} className={className} />;
}

export default function CategoryCards({ categorias, onEscolher }) {
  const visiveis = categorias.filter((c) => c.mostrarNaHome !== false);
  if (visiveis.length === 0) return null;
  return (
    <section data-testid="category-cards" className="border-b border-slate-100 bg-white py-6 sm:py-8">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <h2 className="font-heading text-lg sm:text-xl font-extrabold text-slate-900">Compre por categoria</h2>
        <div className="mt-4 flex gap-3 overflow-x-auto pb-2 snap-x snap-mandatory -mx-4 px-4 sm:mx-0 sm:px-0">
          {visiveis.map((c, i) => (
            <motion.button
              key={c.id}
              data-testid={`category-card-${c.id}`}
              onClick={() => onEscolher(c.id)}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.04 }}
              className="group flex w-28 sm:w-32 shrink-0 snap-start flex-col items-center gap-2.5 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-mk-blue/40 hover:shadow-lg"
            >
              {c.imagem ? (
                <img src={c.imagem} alt={c.nome} className="h-14 w-14 rounded-full object-cover shadow-sm" loading="lazy" />
              ) : (
                <span className="flex h-14 w-14 items-center justify-center rounded-full bg-mk-blue/10 text-mk-blue transition-colors group-hover:bg-mk-blue group-hover:text-white">
                  <IconeCategoria id={c.id} />
                </span>
              )}
              <span className="text-center text-xs sm:text-sm font-bold leading-tight text-slate-700 group-hover:text-mk-blue">
                {c.nome}
              </span>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
}
